import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';

export const CreateOrgPageContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "userDashboard/CreateOrgPageContainer" */
      './CreateOrgPageContainer.dynamic'
    ),
});
